import { useTranslation } from '@hotjar/translations';
import {
  AsideContentWithTrace,
  AuthorInfo,
  AuthorRole,
  AuthorName,
  CompanySize,
  Quote,
  QuoteAuthor,
} from '../../../../styles';
import type { Testimonial } from './data/testimonials';

type PersonalisedTestimonialsProps = {
  background?: 'round' | 'pointy';
  testimonial?: Testimonial;
};

export const PersonalisedTestimonials = ({
  background = 'pointy',
  testimonial,
}: PersonalisedTestimonialsProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (!testimonial) return null;

  const { name, companySize, key } = testimonial;

  return (
    <AsideContentWithTrace background={background}>
      <Quote>{t(`activation:onboarding.testimonials.${key}.quote`)}</Quote>
      <QuoteAuthor>
        <AuthorInfo>
          <AuthorName>{name}</AuthorName>
          <AuthorRole>{t(`activation:onboarding.testimonials.${key}.role`)}</AuthorRole>
          {companySize ? (
            <CompanySize>
              {t(`activation:onboarding.testimonials.common.company-size.${companySize}`)}
            </CompanySize>
          ) : null}
        </AuthorInfo>
      </QuoteAuthor>
    </AsideContentWithTrace>
  );
};
